<template>
  <v-dialog
    v-model="show"
    :max-width="$vuetify.breakpoint.xs ? 'auto' : '500px'"
    persistent
  >
    <v-card class="rounded-xl" color="#ffffffD9">
      <v-card-title class="">
        <span
          class="primary--text text-subtitle-2 text-sm-subtitle-1 text-md-subtitle-1 text-lg-subtitle-1 text-xl-subtitle-1"
          >{{ translations.label_add_image }}</span
        >
      </v-card-title>
      <v-card-text class="my-0 py-0">
        <v-form ref="form_issue" lazy-validation>
          <v-file-input
            v-model="data.file"
            outlined
            accept="image/*, image/heic"
            clearable
            dense
            @change="handleFileChange"
            :label="translations.label_select_image"
            class="text-subtitle-2 text-sm-subtitle-1 text-md-subtitle-1 text-lg-subtitle-1 text-xl-subtitle-1"
            :rules="rules"
          ></v-file-input>

          <div v-if="metadata && isCropIssueTarget">
            <v-divider class="my-4"></v-divider>
            <h3 class="subtitle-1">{{ translations.problem_info }}</h3>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="metadata.kind"
                  :items="availableKinds"
                  item-text="label"
                  item-value="value"
                  :label="translations.problem_type"
                  outlined
                  clearable
                  dense
                  @change="onKindChange"
                  :rules="rules"
                ></v-select>
              </v-col>
              <v-col cols="12" v-if="metadata.kind">
                <v-select
                  v-model="metadata.issue"
                  :items="availableIssues"
                  item-text="label"
                  item-value="value"
                  :label="translations.specific_problem"
                  outlined
                  clearable
                  dense
                  :rules="rules"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                v-if="metadata && metadata.issue && metadata.issue == 'other'"
              >
                <v-text-field
                  v-model="metadata.genericIssue"
                  :label="translations.specific_problem"
                  outlined
                  clearable
                  dense
                  :rules="rules"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </div>

          <v-row>
            <v-col>
              <v-btn
                color="red"
                block
                dark
                class="mb-5 text-subtitle-2 text-sm-subtitle-1 text-md-subtitle-1 text-lg-subtitle-1 text-xl-subtitle-1"
                @click="canceladdPhoto"
              >
                {{ translations.cancel }}
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                color="primary"
                block
                class="mb-5 text-subtitle-2 text-sm-subtitle-1 text-md-subtitle-1 text-lg-subtitle-1 text-xl-subtitle-1"
                @click="addPhoto"
                :disabled="isLoading"
              >
                {{ translations.acept }}
              </v-btn>
            </v-col>
          </v-row>
          <div v-if="metadata">
            <v-row>
              <v-col>
                <p>
                  <strong>{{ translations.hint_date }}:</strong>
                  {{ getFormattedSimple(metadata.dateTimeOriginal) }}
                </p>
                <div v-if="metadata.latitude">
                  <p>
                    <strong>{{ translations.label_latitude }}:</strong>
                    {{ metadata.latitude }}
                  </p>
                  <p>
                    <strong>{{ translations.label_longitude }}:</strong>
                    {{ metadata.longitude }}
                  </p>
                </div>
                <div v-else>
                  <v-form lazy-validation ref="form">
                    <v-row>
                      <v-col class="pb-0">
                        <v-text-field
                          type="number"
                          dense
                          outlined
                          :label="translations.label_latitude"
                          :rules="rules"
                          v-model="lat"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0">
                        <v-text-field
                          type="number"
                          dense
                          outlined
                          :label="translations.label_longitude"
                          :rules="rules"
                          v-model="lng"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-carousel
                  hide-delimiter-background
                  :show-arrows="false"
                  height="auto"
                  :max-width="$vuetify.breakpoint.xs ? 'auto' : '500px'"
                  class="mt-0"
                >
                  <v-carousel-item>
                    <v-img :src="imageUrl" contain> </v-img>
                  </v-carousel-item>
                </v-carousel>
              </v-col>
            </v-row>
          </div>
          <v-row v-if="isLoading">
            <v-col>
              <v-progress-linear
                color="primary accent-4"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { findEXIFinHEIC } from "./exif-heic.js";
import heic2any from "heic2any";
import EXIF from "exif-js";
import moment from "moment";
// Validations
import { requiredValidation } from "@/helpers/validations.js";

export default {
  props: {
    value: Boolean,
    target: {
      type: String,
      default: "subsample",
    },
  },
  data: () => ({
    data: { error: false, message: "", file: null },
    imageUrl: null,
    metadata: null,
    isLoading: false,
    rules: null,
    lat: null,
    lng: null,
  }),
  created() {
    this.rules = requiredValidation(this.translations.field_required);
    if (this.samplingPoints && this.samplingPoints.length > 0) {
      const lastPoint = this.samplingPoints[this.samplingPoints.length - 1];
      this.lat = lastPoint.getGeometry
        ? lastPoint.getGeometry().lat
        : lastPoint.lat;
      this.lng = lastPoint.getGeometry
        ? lastPoint.getGeometry().lng
        : lastPoint.lng;
    }
  },
  computed: {
    ...mapState("samples", ["samplingPoints"]),
    ...mapGetters("session", ["currentTranslations"]),
    ...mapState("areasList", ["areaSelected"]),

    translations() {
      return this.currentTranslations;
    },

    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },

    isCropIssueTarget() {
      if (
        !this.areaSelected ||
        !this.areaSelected.cropCycles ||
        this.areaSelected.cropCycles.length === 0 ||
        this.target != "issue"
      )
        return false;

      const currentCrop = this.areaSelected.cropCycles[
        this.areaSelected.cropCycles.length - 1
      ].crop.cropName;

      if (!currentCrop) return false;

      switch (currentCrop) {
        case "avocado":
          return true;

        default:
          return false;
      }
    },

    availableKinds() {
      return [
        { label: this.translations.disease, value: "DISEASE" },
        { label: this.translations.plague, value: "PLAGUE" },
        // { label: this.translations.weed, value: "WEED" },
        // { label: this.translations.nutrition, value: "NUTRITION" },
      ];
    },

    availableIssues() {
      if (!this.metadata || !this.metadata.kind) return [];

      if (this.metadata.kind === "DISEASE") {
        return [
          {
            label: this.translations.avocado_disease_list.unknown,
            value: "unknown",
          },
          {
            label: this.translations.avocado_disease_list.damping_off,
            value: "Pythium sp.",
          },
          {
            label: this.translations.avocado_disease_list.anthracnose_classic,
            value: "Colletotrichum gloeosporioides",
          },
          {
            label: this.translations.avocado_disease_list.anthracnose_boninense,
            value: "Colletotrichum boninense",
          },
          {
            label: this.translations.avocado_disease_list.bacterial_canker,
            value: "Xanthomonas sp.",
          },
          {
            label: this.translations.avocado_disease_list.sooty_mold,
            value: "Capnodium sp.",
          },
          {
            label: this.translations.avocado_disease_list.angular_leaf_spot,
            value: "Cercospora purpurea",
          },
          {
            label: this.translations.avocado_disease_list.tar_spot,
            value: "Phyllachora gratissima",
          },
          {
            label: this.translations.avocado_disease_list.leaf_spot_septoria,
            value: "Septoria sp.",
          },
          {
            label: this.translations.avocado_disease_list.black_spot,
            value: "Diplocarpon rosae",
          },
          {
            label: this.translations.avocado_disease_list.fusarium_wilt,
            value: "Fusarium sp.",
          },
          {
            label: this.translations.avocado_disease_list.root_rot_rhizoctonia,
            value: "Rhizoctonia solani",
          },
          {
            label: this.translations.avocado_disease_list.fruit_rot_diplodia,
            value: "Diplodia sp.",
          },
          {
            label: this.translations.avocado_disease_list.fruit_rot_dothiorella,
            value: "Dothiorella sp.",
          },
          {
            label: this.translations.avocado_disease_list.scab,
            value: "Sphaceloma perseae",
          },
          {
            label: this.translations.avocado_disease_list.avocado_root_rot,
            value: "Phytophthora cinnamomi",
          },
          {
            label: this.translations.avocado_disease_list.botrytis_cinerea,
            value: "Botrytis cinerea",
          },
          {
            label: this.translations.avocado_disease_list.cladosporium_fulvum,
            value: "Cladosporium fulvum",
          },
          {
            label: this.translations.avocado_disease_list
              .colletotrichum_acutatum,
            value: "Colletotrichum acutatum",
          },
          {
            label: this.translations.avocado_disease_list.glomerella_cingulata,
            value: "Glomerella cingulata",
          },
          {
            label: this.translations.avocado_disease_list.monilia_spp,
            value: "Monilia spp.",
          },
          {
            label: this.translations.avocado_disease_list
              .mycosphaerella_fragariae,
            value: "Mycosphaerella fragariae",
          },
          {
            label: this.translations.avocado_disease_list.peronospora_rubi,
            value: "Peronospora rubi",
          },
          {
            label: this.translations.avocado_disease_list.other,
            value: "other",
          },
        ];
      } else if (this.metadata.kind === "PLAGUE") {
        return [
          {
            label: this.translations.avocado_plague_list.unknown,
            value: "unknown",
          },
          {
            label: this.translations.avocado_plague_list.oligonychus_yothersi,
            value: "Oligonychus yothersi",
          },
          {
            label: this.translations.avocado_plague_list.oligonychus_perseae,
            value: "Oligonychus perseae",
          },
          {
            label: this.translations.avocado_plague_list.oligonychus_punicae,
            value: "Oligonychus punicae",
          },
          {
            label: this.translations.avocado_plague_list.oligonychus_mexicanus,
            value: "Oligonychus mexicanus",
          },
          {
            label: this.translations.avocado_plague_list.copturus_aguacatae,
            value: "Copturus aguacatae",
          },
          {
            label: this.translations.avocado_plague_list.heilipus_lauri,
            value: "Heilipus lauri",
          },
          {
            label: this.translations.avocado_plague_list
              .conotrachelus_aguacatae,
            value: "Conotrachelus aguacatae",
          },
          {
            label: this.translations.avocado_plague_list.idona_minuenda,
            value: "Idona minuenda",
          },
          {
            label: this.translations.avocado_plague_list.empoasca_abrupta,
            value: "Empoasca abrupta",
          },
          {
            label: this.translations.avocado_plague_list.hemiberlesia_lataniae,
            value: "Hemiberlesia lataniae",
          },
          {
            label: this.translations.avocado_plague_list.pyrrhopyge_chalybea,
            value: "Pyrrhopyge chalybea",
          },
          {
            label: this.translations.avocado_plague_list.gonodonta_pyrgo,
            value: "Gonodonta pyrgo",
          },
          {
            label: this.translations.avocado_plague_list.sabulodes_aegrotata,
            value: "Sabulodes aegrotata",
          },
          {
            label: this.translations.avocado_plague_list.copaxa_multifenestrata,
            value: "Copaxa multifenestrata",
          },
          {
            label: this.translations.avocado_plague_list.amorbia_cuneana,
            value: "Amorbia cuneana",
          },
          {
            label: this.translations.avocado_plague_list.gracillaria_spp,
            value: "Gracillaria spp.",
          },
          {
            label: this.translations.avocado_plague_list.aleurodes_sp,
            value: "Aleurodes sp.",
          },
          {
            label: this.translations.avocado_plague_list.tetraleurodes_perseae,
            value: "Tetraleurodes perseae",
          },
          {
            label: this.translations.avocado_plague_list.aleurodicus_dugesii,
            value: "Aleurodicus dugesii",
          },
          {
            label: this.translations.avocado_plague_list.bemisia_argentifolii,
            value: "Bemisia argentifolii",
          },
          {
            label: this.translations.avocado_plague_list.paraleyrodes_perseae,
            value: "Paraleyrodes perseae",
          },
          {
            label: this.translations.avocado_plague_list.aethalion_quadratum,
            value: "Aethalion quadratum",
          },
          {
            label: this.translations.avocado_plague_list.stenoma_catenifer,
            value: "Stenoma catenifer",
          },
          {
            label: this.translations.avocado_plague_list.metcalfiella_monograma,
            value: "Metcalfiella monograma",
          },
          {
            label: this.translations.avocado_plague_list.trioza_anceps,
            value: "Trioza anceps",
          },
          {
            label: this.translations.avocado_plague_list
              .neohydatothrips_signifer,
            value: "Neohydatothrips signifer",
          },
          {
            label: this.translations.avocado_plague_list
              .pseudophilothrips_perseae,
            value: "Pseudophilothrips perseae",
          },
          {
            label: this.translations.avocado_plague_list
              .heliothrips_haemorrhoidalis,
            value: "Heliothrips haemorrhoidalis",
          },
          {
            label: this.translations.avocado_plague_list.scirtothrips_perseae,
            value: "Scirtothrips perseae",
          },
          {
            label: this.translations.avocado_plague_list.frankliniella_bruneri,
            value: "Frankliniella bruneri",
          },
          {
            label: this.translations.avocado_plague_list
              .frankliniella_occidentalis,
            value: "Frankliniella occidentalis",
          },
          {
            label: this.translations.avocado_plague_list.tetranychus_urticae,
            value: "Tetranychus urticae",
          },
          {
            label: this.translations.avocado_plague_list.liriomyza_sp,
            value: "Liriomyza sp.",
          },
          {
            label: this.translations.avocado_plague_list.tuta_absoluta,
            value: "Tuta absoluta",
          },
          {
            label: this.translations.avocado_plague_list.aphis_sp_green,
            value: "Aphis sp.",
          },
          {
            label: this.translations.avocado_plague_list.diaphorina_citri,
            value: "Diaphorina citri",
          },
          {
            label: this.translations.avocado_plague_list.spodoptera_frugiperda,
            value: "Spodoptera frugiperda",
          },
          {
            label: this.translations.avocado_plague_list
              .keiferia_lycopersicella,
            value: "Keiferia lycopersicella",
          },
          {
            label: this.translations.avocado_plague_list.helicoverpa_zea,
            value: "Helicoverpa zea",
          },
          {
            label: this.translations.avocado_plague_list.heliothis_virescens,
            value: "Heliothis virescens",
          },
          {
            label: this.translations.avocado_plague_list.trichoplusia_ni,
            value: "Trichoplusia ni",
          },
          {
            label: this.translations.avocado_plague_list
              .manduca_quinquemaculata,
            value: "Manduca quinquemaculata",
          },
          {
            label: this.translations.avocado_plague_list.spodoptera_exigua,
            value: "Spodoptera exigua",
          },
          {
            label: this.translations.avocado_plague_list.liriomyza_spp,
            value: "Liriomyza spp",
          },
          {
            label: this.translations.avocado_plague_list.cydia_pomonella,
            value: "Cydia pomonella",
          },
          {
            label: this.translations.avocado_plague_list
              .phthorimaea_operculella,
            value: "Phthorimaea operculella",
          },
          {
            label: this.translations.avocado_plague_list.heliothis_zea,
            value: "Heliothis zea",
          },
          {
            label: this.translations.avocado_plague_list
              .pectinophora_gossypiella,
            value: "Pectinophora gossypiella",
          },
          {
            label: this.translations.avocado_plague_list
              .bucculatrix_thurberiella,
            value: "Bucculatrix thurberiella",
          },
          {
            label: this.translations.avocado_plague_list.estigmene_acrea,
            value: "Estigmene acrea",
          },
          {
            label: this.translations.avocado_plague_list.copitarsia_consueta,
            value: "Copitarsia consueta",
          },
          {
            label: this.translations.avocado_plague_list.plutella_xylostella,
            value: "Plutella xylostella",
          },
          {
            label: this.translations.avocado_plague_list.liriomyza_munda,
            value: "Liriomyza munda",
          },
          {
            label: this.translations.avocado_plague_list.manduca_sexta,
            value: "Manduca sexta",
          },
          {
            label: this.translations.avocado_plague_list.diatraea_grandiosella,
            value: "Diatraea grandiosella",
          },
          {
            label: this.translations.avocado_plague_list.carpocapsa_pomonella,
            value: "Carpocapsa pomonella",
          },
          {
            label: this.translations.avocado_plague_list.aeneolamia_contigua,
            value: "Aeneolamia contigua",
          },
          {
            label: this.translations.avocado_plague_list.other,
            value: "other",
          },
        ];
      }
      // else if (this.metadata.kind === "WEED") {
      //   return [
      //     {
      //       label: this.translations.avocado_weeds_list.chenopodium_album,
      //       value: "Chenopodium album",
      //     },
      //     {
      //       label: this.translations.avocado_weeds_list.equisetum_spp,
      //       value: "Equisetum spp.",
      //     },
      //     {
      //       label: this.translations.avocado_weeds_list.eleusine_indica,
      //       value: "Eleusine indica",
      //     },
      //     {
      //       label: this.translations.avocado_weeds_list.convolvulus_arvensis,
      //       value: "Convolvulus arvensis",
      //     },
      //     {
      //       label: this.translations.avocado_weeds_list.euphorbia_prostrata,
      //       value: "Euphorbia prostrata",
      //     },
      //     {
      //       label: this.translations.avocado_weeds_list.rumex_crispus,
      //       value: "Rumex crispus",
      //     },
      //     {
      //       label: this.translations.avocado_weeds_list.sorghum_halepense,
      //       value: "Sorghum halepense",
      //     },
      //     {
      //       label: this.translations.avocado_weeds_list.setaria_verticillata,
      //       value: "Setaria verticillata",
      //     },
      //     {
      //       label: this.translations.avocado_weeds_list.cyperus_rotundus,
      //       value: "Cyperus rotundus",
      //     },
      //     {
      //       label: this.translations.avocado_weeds_list.other,
      //       value: "other",
      //     },
      //   ];
      // } else if (this.metadata.kind === "NUTRITION") {
      //   return [
      //     {
      //       label: this.translations.avocado_nutrition.nitrogen,
      //       value: "N",
      //     },
      //     {
      //       label: this.translations.avocado_nutrition.zinc,
      //       value: "Zn",
      //     },
      //     {
      //       label: this.translations.avocado_nutrition.iron,
      //       value: "Fe",
      //     },
      //     {
      //       label: this.translations.avocado_nutrition.potassium,
      //       value: "K",
      //     },
      //     {
      //       label: this.translations.avocado_nutrition.boro,
      //       value: "B",
      //     },
      //     {
      //       label: this.translations.avocado_nutrition.other,
      //       value: "other",
      //     },
      //   ];
      // }

      return [];
    },
  },
  methods: {
    async handleFileChange(file) {
      if (file) {
        if (file.type === "image/heic") {
          try {
            this.extractExifDataHEIC(file);
          } catch (error) {
            console.error("Error al convertir HEIC:", error);
          }
        } else {
          this.extractExifData(file);
        }
      } else {
        this.metadata = null;
      }
    },

    async extractExifDataHEIC(file) {
      this.isLoading = true;
      const convertedBlob = await heic2any({
        blob: file,
        toType: "image/jpeg",
      });
      this.imageUrl = URL.createObjectURL(convertedBlob);
      const reader = new FileReader();

      reader.onload = () => {
        let tags = findEXIFinHEIC(reader.result);
        const dateTimeOriginal = tags["DateTimeOriginal"];
        const lat = tags["GPSLatitude"];
        const lon = tags["GPSLongitude"];
        const latRef = tags["GPSLatitudeRef"];
        const lonRef = tags["GPSLongitudeRef"];

        const latitude = lat ? this.convertToDecimal(lat, latRef) : null;
        const longitude = lon ? this.convertToDecimal(lon, lonRef) : null;

        this.metadata = {
          dateTimeOriginal:
            dateTimeOriginal || moment().format("YYYY:MM:DD HH:mm:ss"),
          latitude,
          longitude,
          file: convertedBlob,
          kind: null,
          issue: null,
        };
        this.isLoading = false;
      };

      reader.readAsArrayBuffer(file);
    },

    extractExifData(file) {
      this.imageUrl = URL.createObjectURL(file);
      const reader = new FileReader();
      reader.onload = (event) => {
        const image = new Image();
        image.onload = () => {
          EXIF.getData(image, () => {
            const dateTimeOriginal = EXIF.getTag(image, "DateTimeOriginal");
            const lat = EXIF.getTag(image, "GPSLatitude");
            const lon = EXIF.getTag(image, "GPSLongitude");
            const latRef = EXIF.getTag(image, "GPSLatitudeRef");
            const lonRef = EXIF.getTag(image, "GPSLongitudeRef");

            const latitude = lat ? this.convertToDecimal(lat, latRef) : null;
            const longitude = lon ? this.convertToDecimal(lon, lonRef) : null;

            this.metadata = {
              dateTimeOriginal:
                dateTimeOriginal || moment().format("YYYY:MM:DD HH:mm:ss"),
              latitude,
              longitude,
              file,
              kind: null,
              issue: null,
            };
            this.isLoading = false;
          });
        };
        image.src = event.target.result;
      };
      reader.readAsDataURL(file);
    },

    convertToDecimal(coord, ref) {
      if (!coord) return null;
      const decimal = coord[0] + coord[1] / 60 + coord[2] / 3600;
      return ref === "S" || ref === "W" ? -decimal : decimal;
    },

    getFormattedSimple(date) {
      return date
        ? moment(date, "YYYY:MM:DD HH:mm:ss").format("YYYY/MM/DD HH:mm")
        : "----/--/--";
    },

    onKindChange() {
      if (this.metadata) {
        this.metadata.issue = null;
      }
    },

    canceladdPhoto() {
      this.$emit("removeLastPoint");
    },

    addPhoto() {
      if (!this.$refs.form_issue.validate()) return;
      if (this.metadata == null) {
        this.$emit("addPhoto", {
          dateTimeOriginal: moment(new Date()).format("YYYY:MM:DD HH:mm:ss"),
          latitude: this.samplingPoints[
            this.samplingPoints.length - 1
          ].getGeometry().lat,
          longitude: this.samplingPoints[
            this.samplingPoints.length - 1
          ].getGeometry().lng,
          kind: null,
          issue: null,
        });
      } else {
        if (this.metadata.latitude) {
          if (this.metadata.genericIssue && (this.metadata.issue == "other" || this.metadata.issue == "unknown")) {
            this.metadata.issue = this.metadata.genericIssue;
            this.metadata.isGeneric = true;
          }
          this.$emit("addPhoto", this.metadata);
        } else {
          if (this.$refs.form.validate()) {
            this.metadata.latitude = this.lat;
            this.metadata.longitude = this.lng;
            if (this.metadata.genericIssue && (this.metadata.issue == "other" || this.metadata.issue == "unknown")) {
              this.metadata.issue = this.metadata.genericIssue;
              this.metadata.isGeneric = true;
            }
            this.$emit("addPhoto", this.metadata);
          }
        }
      }
    },
  },
};
</script>

<style scoped></style>
